import styled, { css } from 'styled-components';

export const Content = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  font-size: 14px;
  line-height: 1;
  color: #aaa;
  padding: 0 10px 10px;
  margin: 0 0 10px;
  border-bottom: 1px solid #aaa;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      border-bottom-color: ${(props) => (props.theme.theme === 'dark' ? '#aaa' : '#333')};
      color: ${(props) => (props.theme.theme === 'dark' ? '#aaa' : '#333')};
    `}
`;

export const Headers = styled.div`
  display: flex;
`;

export const Input = styled.div`
  margin: 0 20px 0 0;
`;

export const ZoneLabel = styled.div`
  color: var(--cp-text, #fff);
  white-space: nowrap;
  line-height: 40px;
  /* width: 260px; */
  text-align: left;
`;
